/**
 * @author Brendan Magee
 * @desc component for enabling and disabling notification trigger fields
 * @example <enable-field field-type="typeString" field-title="TITLE_STRING"></enable-field>
 */

import template from './enableField.html';

const enableField = {
  template,
  bindings: {
    fieldType: '@',
    fieldTitle: '@'
  },
  require: {
    parent: '^notificationTrigger'
  }
};

export default function (ngModule) {
  ngModule.component('enableField', enableField);
}
